export default __webpack_public_path__ + "static/media/honeywelllogo.6ad2d8dc.png";